export type CardStatus =
  | 'cardBlocked'
  | 'userDeleted'
  | 'cardExpired'
  | 'accessRightsChanged'
  | 'userExpiresSoon'
  | 'cardExpiresSoon';

export interface AccessCardEntry {
  id: string;
  uuid: string;
  name: string | null;
  visitorName: string;
  visitorEmail: string | null;
  expiryDate: string | null;
  expired: boolean;
  assigned: boolean;
  blocked: boolean;
  blockedSince: string | null;
  blockedReason: string | null;
  statuses: CardStatus[];
}

export interface FilterStatusState {
  cardBlocked: boolean;
  userDeleted: boolean;
  cardExpired: boolean;
  accessRightsChanged: boolean;
  userExpiresSoon: boolean;
}

export const FilterValidity = {
  OneDay: '1day',
  ThreeDays: '3days',
  OneWeek: '1week',
  OneMonth: '1month'
} as const;

export type FilterValidity = (typeof FilterValidity)[keyof typeof FilterValidity];

export type FilterValidityState = FilterValidity | null;

export const FilterAssignedState = {
  Assigned: 'assigned',
  Unassigned: 'unassigned'
} as const;

export type FilterAssignedState = (typeof FilterAssignedState)[keyof typeof FilterAssignedState] | null;

export type AccessCardsFilter = {
  filterStatus: FilterStatusState;
  filterValidity: FilterValidityState;
  filterAssigned: FilterAssignedState;
};

export type AccessCardsFilterSetters = {
  setFilterStatus: (value: FilterStatusState | ((current: FilterStatusState) => FilterStatusState)) => void;
  setFilterValidity: (value: FilterValidityState) => void;
  setFilterAssigned: (value: FilterAssignedState) => void;
};

export interface AccessCardsFilterState {
  filter: AccessCardsFilter;
  setters: AccessCardsFilterSetters;
  clearAllFilters: () => void;
  isAnyFilterEnabled: boolean;
}
